<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Service Providers Users</h3>
        <div class="text-xs-right">
          <!-- <export-button
              class="ml-2"
              v-if="$oauth.checkIfHasPermission(['export service-provider'])"/>
          <refresh-button :click-function="getAll"></refresh-button> -->
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex class="pb-0">
              <v-text-field
                  :elevation="0"
                  class="hidden-sm-and-down "
                  flat
                  hide-details
                  placeholder="Search by User name..."
                  prepend-inner-icon="search"
                  solo
                  v-model="filters.query"
                  @keypress.enter="handleFilterChange"
              ></v-text-field>
            </v-flex>
            <v-flex sm6 class="pb-0">
              <v-autocomplete
                  :items="service_providers"
                  item-value="id"
                  item-text="name"
                  flat
                  hide-details
                  label="Filter By Service Provider"
                  @change="handleFilterChange"
                  prepend-inner-icon="filter_list"
                  solo
                  clearable
                  v-model="filters.service_providers"
              />
            </v-flex>

          </v-layout>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
                :footer-props="footerProps"
                :headers="headers"
                :items="usersList"
                :loading="loading"
                :options.sync="pagination"
                :server-items-length="totalNumber"
                item-key="id">
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FileInput from "../components/FileInput";
import {commonListMixin} from "../mixins/commonListMixin";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import {validationMixin} from "../mixins/validationMixin";
import RefreshButton from "@/components/RefreshButton";
import FileDisplay from "../components/FileDisplay";
import TableStatus from "@/components/TableStatus";
import {mapGetters} from "vuex";


export default {
  name: "ServiceProvider",
  components: {FileDisplay, RefreshButton, FormErrorDisplayHandler, FileInput, TableStatus},
  data() {
    return {
      model: "service-provider-users",
      types: [],
      headers: [
        {
          text: 'S.N.',
          value: 's_no',
          sortable: false
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Email",
          value: "email",
          sortable: false
        },
        {
          text: 'User Contact',
          value: 'mobile_number'
        },
        {
          text: 'Service Provider Name',
          value: 'service_provider.name'
        },
        // {
        //   text: "Action",
        //   value: "action",
        //   sortable: false
        // }
      ],
    };
  },

  mixins: [commonListMixin, validationMixin],

  computed: {
    usersList() {
      return this.$store.state.CommonList.all;
    },
    ...mapGetters({
      service_providers_users: "ServiceProvider/serviceProviderUser",
      service_providers: "ServiceProvider/serviceProvider",

    }),
  },
  methods:{
    getServiceProvidersUsers() {
      this.$store.dispatch("ServiceProvider/getAllServiceProviderUsers")
    },
    getServiceProviders() {
      this.$store.dispatch("ServiceProvider/getAllServiceProvider")
    },
  },
  mounted() {
    this.$store.commit("CommonList/setModel", this.model);
    this.getServiceProvidersUsers()
    this.getServiceProviders()
  }
}
</script>

<style scoped>

</style>



